





































import Vue from 'vue';
import { AccountType, AccountLogo } from 'mycorems-app-accounts';
import { Account } from '@/types';
import eventBus from '@/messaging/event-bus';
import { ClientEdited } from '@/messaging/events';
import EditClientBtn from './client/EditClientBtn.vue';
import ClientDropdown from './client/ClientDropdown.vue';
import CompanyDropdown from './company/CompanyDropdown.vue';
import ClientPricePlanInfo from '../account-price-plan/ClientPricePlanInfo.vue';
import PurchaseMoreBtn from '../account-price-plan/PurchaseMoreBtn.vue';
import AutoRenewBtnToggle from '../account-price-plan/AutoRenewBtnToggle.vue';

export default Vue.extend({
  props: {
    account: {
      type: Object as () => Account,
      required: true,
    },
  },
  computed: {
    isClient(): boolean {
      return (this.account.type === AccountType.CLIENT);
    },
    isCompany(): boolean {
      return (this.account.type === AccountType.COMPANY);
    },
  },
  methods: {
    onClientEdited(event: ClientEdited): void {
      this.account.name = event.name;
    },
  },
  created(): void {
    eventBus.$on(ClientEdited.eventName, this.onClientEdited);
  },
  beforeDestroy(): void {
    eventBus.$off(ClientEdited.eventName, this.onClientEdited);
  },
  components: {
    'account-logo': AccountLogo,
    'edit-client-btn': EditClientBtn,
    'client-dropdown': ClientDropdown,
    'company-dropdown': CompanyDropdown,
    'client-price-plan-info': ClientPricePlanInfo,
    'purchase-more-btn': PurchaseMoreBtn,
    'auto-renew-btn-toggle': AutoRenewBtnToggle,
  },
});
